<template>
    <div class="article">
        <el-button v-loading.fullscreen.lock="loading" @click="saveAsync" size="small" type="primary">保存</el-button>
        <div style="width:1000px;margin-top:30px">
            <el-input v-model="title" placeholder="文章标题"></el-input>
        </div>


        <!-- <editor-bar v-loading.lock="loading" v-model="content" @change="change"></editor-bar> -->
        <Editor id="tinymce" v-model="content" :init="editorProps"></Editor>

        <el-upload class="upload-demo"
                   drag
                   v-if="upLoadShow"
                   accept=".pdf"
                   :on-preview="handlePreview"
                   :action="uploadUrl"
                   :headers="headers"
                   :on-success="success"
                   :on-error="error"
                   :file-list="uploadFileList"
                   :before-remove="handleRemoveFile"
                   multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>

        <!-- <el-upload class="upload-demo"
                   drag
                   :action="uploadUrl"
                   :on-change="handleChange"
                   :file-list="uploadFileList"
                   :show-file-list="true"
                   :before-remove="handleRemoveFile">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip"></div>
        </el-upload> -->
    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue'
    import tinymce from 'tinymce/tinymce'
    import 'tinymce/themes/silver/theme'
    import 'tinymce/icons/default/icons'
    import '../../../../public/tinymce/plugins/imageSelector/plugin'
    import url from '@/api/config.js'
    import { articleDetail,articleAddOrUpdate,deleteFile } from '@/api/cms.js'
    export default {
        components: {
            Editor
        },
        data() {
            return {
                headers: {
					session: window.$cookies.get("session"),
					zone: window.$cookies.get("zone"),
				},
                articleId: null,
                columnId: String,
                title: '',
                content: '',
                uploadUrl: '/cms/article/uploadFile?id=',
                uploadParam: {
                    id: ''
                },
                uploadRequestHeaders: {
                    Authorization: 'Bearer ' + ''
                },
                uploadFileList: [],
                loading: false,
                upLoadShow: false,
                editorProps: {
                    width: 1000,
                    height: 500,
                    skin_url: '/tinymce/skins/ui/oxide',
                    language_url: '/tinymce/langs/zh_CN.js',
                    language: 'zh_CN',//注意大小写
                    menubar: false,
                    statusbar: false,
                    convert_urls: false,
                    toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat',
                    plugins: 'imageSelector',
                    init_instance_callback: (editor) => {
                    }
                }
            }
        },
        mounted() {
            tinymce.init({})
        },
        async created() {
            this.articleId = this.$route.query.articleId
            this.columnId = this.$route.query.columnId
            this.uploadUrl = `${url.baseUrl.dev}cms/article/uploadFile?id=${this.articleId}`
            console.log(this.uploadUrl)
            // let user = await UserManager.mgr.getUser()
            // this.uploadRequestHeaders.Authorization = 'Bearer ' + user.access_token;

            await this.getDetailAsync()
        },
        methods: {
            /**点击已上传文件 */
			handlePreview(file) {
				console.log(file, 33333);
			},
            // 上传成功
			success(response) {
                this.$message.success('上传成功')
                console.log(response)
			},
            // 上传失败
			error(err) {
                this.$message.error('上传失败')
                console.log(err)
			},
            async getDetailAsync() {
                if (this.articleId == null) {
                    return
                }
                this.loading = true
                try {
                    let res = await articleDetail({
                        id:this.articleId
                    })
                    if (res.status == 0) {
                        this.title = res.article.title
                        this.content = res.article.content
                        this.upLoadShow = true
                        this.uploadFileList = res.files.map(e => {
                            return {
                                name: e.filename,
                                id: e.id
                            }
                        })
                    }
                }
                finally {
                    this.loading = false
                }
            },
            async saveAsync() {
                this.loading = true
                try {
                    let body = {
                        id: this.articleId,
                        columnId: this.columnId,
                        title: this.title,
                        content: this.content,
                    }
                    let res = await articleAddOrUpdate(body)
                    if (res.status === 0) {
                        if (this.articleId === null){
                            this.articleId = res.id
                            this.uploadUrl = `${url.baseUrl.dev}cms/article/uploadFile?id=${this.articleId}`
                            this.upLoadShow = true
                        }
                        this.$message.success('保存成功')
                    }
                    else
                        this.$message.error('保存失败 ' + res.phrase)
                }
                finally {
                    this.loading = false
                }
            },
            change(val) {
                // console.info(this.uploadFileList)
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                //console.log('preview', file);
            },
            handleChange(file, fileList) {
            },
            async handleRemoveFile(file, fileList) {
                console.info('delete file ', file)
                let body = {
                    id: this.articleId,
                    fileId: file.id ? file.id : file.response.id
                }
                try {
                    let response = await deleteFile(body)
                    if (response.status == 0) {
                        this.$message.success('已删除')
                        return true
                    }
                }
                catch (ex) {
                    this.$message.error('删除失败 ' + response.phrase)
                    return false
                }
            }
        },
    }
</script>
<style scoped>
    .article {
        padding: 50px;
    }
</style>
